import { Stripe } from "components/Onboarding/Stripe/Stripe";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/onboarding/stripe")({
    component: Stripe,
});
